

import { Injectable } from '@angular/core';
import { AttendenceExportModel } from './models/attendence-export.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class AttendenceExportService {



  constructor(private http: HttpClient) { }

  getList(requestData: any): Observable<any> {
    return this.http.post(environment.baseUrl + 'attendance-data/get', requestData);

  }

  getById(payload: any): Observable<any> {
    return this.http.post(environment.baseUrl + '/attendance-data/get-employee', payload);
  }
  update(payload: any): Observable<any> {
    return this.http.post(environment.baseUrl + '/attendance-data/update', payload);
  }
  updateAttendance(payload: any): Observable<any> {
    return this.http.post(environment.baseUrl + 'attendance-data/update-attendance', payload);
  }
  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL

    return this.http.post(environment.baseUrl + '/attendance-data/export', requestData, { headers, responseType: 'blob' })
      .pipe(
      //catchError(this.handleError)
    );
  }
  proceedChecking(requestData: any): Observable<any> {
    return this.http.post(environment.baseUrl + 'attendance-data/attendance-check', requestData);

  }
  exportAttendance(requestData: any): Observable<any> {
    return this.http.post(environment.baseUrl + 'attendance-data/export-attendance-data', requestData);

  }
}
